@if (user) {
    <div class="row">
        <div class="col-12 col-md-3 col-xxl-2">
            <aside id="collection-sets">
                <ul>
                    <li [ngClass]="{'active':  selectedType === 'my'}">
                        <button mat-button (click)="selectType('my')">
                            <mat-icon fontIcon="person"></mat-icon>
                            {{ 'collections.selection.my'|translate }}
                        </button>
                    </li>
                    <li [ngClass]="{'active':  selectedType === 'shared'}">
                        <button mat-button (click)="selectType('shared')">
                            <mat-icon fontIcon="share"></mat-icon>
                            {{ 'collections.selection.shared'|translate }}
                        </button>
                    </li>
                    <li [ngClass]="{'active':  selectedType === 'published'}">
                        <button mat-button (click)="selectType('published')">
                            <mat-icon fontIcon="language"></mat-icon>
                            {{ 'collections.selection.published'|translate }}
                        </button>
                    </li>
                </ul>
                <div class="search">
                    <h3 class="mb-3">{{'collections.searchHL' | translate}} {{ 'collections.selection.' + selectedType|translate }} </h3>
                    <form (submit)="refreshCollectionView()" [formGroup]="searchForm">
                        <div id="collection-search" class="mb-3 ">
                            <mat-form-field>
                                <mat-label>{{ 'collections.search'|translate }}</mat-label>
                                <input matInput type="text" formControlName="searchTerm">
                            </mat-form-field>

                            <button mat-icon-button type="submit">
                                <mat-icon>search</mat-icon>
                            </button>
                        </div>
                    </form>
                    <div id="collection-order">
                        <mat-form-field>
                            <!--<mat-label>{{'collection.orderby' | translate}}</mat-label>-->
                            <mat-select  [(ngModel)]="selectedOrderBy" (selectionChange)="refreshCollectionView()">
                                <mat-option class="option" [value]="OrderBy.created">{{'collection.orderby' | translate}} <span class="bold">{{ OrderBy.created |translate }}</span></mat-option>
                                <mat-option class="option" [value]="OrderBy.modified">{{'collection.orderby' | translate}} <span class="bold">{{ OrderBy.modified |translate }}</span></mat-option>
                            </mat-select>
                        </mat-form-field>
                        @if (selectedOrderDir === OrderDirection.desc) {
                            <button mat-icon-button>
                                <mat-icon (click)="toggleSortOrder()" fontIcon="arrow_downward"></mat-icon>
                            </button>
                        }
                        @if (selectedOrderDir === OrderDirection.asc) {
                            <button mat-icon-button>
                                <mat-icon (click)="toggleSortOrder()" fontIcon="arrow_upward"></mat-icon>
                            </button>
                        }
                    </div>

                </div>
            </aside>
        </div>
        <div class="col-12 col-md-9 col-xxl-10">
            <header id="collection-header">
                <h1>{{ 'collections.selection.' + selectedType|translate }}</h1>
                <div id="collection-new">
                    <button mat-raised-button (click)="createCollection()">{{ 'collections.new'|translate }}</button>
                </div>
            </header>

            <section id="collection-result" appFullHigh #scroller>
                <div class="row row-cols-auto justify-content-start">
                    @for (col of collections; track col; let i = $index) {
                        @defer (on viewport; prefetch on immediate) {
                            <div class="col">
                                <app-collection-tile [collection]="col" [index]=i (loaded)="onCollectionLoaded($event)"
                                                     (remove)="onCollectionRemoved($event)" (open)="onOpenCollection($event)"></app-collection-tile>
                            </div>
                        } @placeholder {
                            <div class="col">
                                <div class="collection-tile">
                                    <div>{{'collections.loading'|translate}}</div>
                                </div>
                            </div>
                        } @error {
                            <div class="col">
                                @if(i === 0) {
                                    <div class="collection-tile">
                                        <div class="reload">
                                            <div>
                                                <h3>{{'newVersion' | translate}}</h3>
                                                <p>{{'reload' |translate}}</p>
                                            </div>
                                           <div>
                                               <button (click)="reloadApp()" mat-raised-button>{{'btn.reload' |translate}}</button>
                                           </div>

                                        </div>
                                    </div>
                                }

                            </div>
                        }

                    }
                    @if (collections.length === 0) {
                        <div class="col">
                            {{'collections.empty'|translate}}
                        </div>
                    }
                </div>

            </section>
        </div>
    </div>
}






